import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "power-bi" }
const _hoisted_2 = ["src"]

import { ref, onMounted, onBeforeUnmount } from "vue";
import log from "loglevel";


export default /*#__PURE__*/_defineComponent({
  __name: 'Dashboard',
  setup(__props) {

document.title = 'Home - UV'

const pbi: string = process.env.VUE_APP_POWER_BI_REPORT_URL!;

// Create a ref to store the visibility state
const isPageVisible = ref(true);

// Bind iframe key to reactive property
const iframeKey = ref(0);

// Function to handle visibility change
const handleVisibilityChange = () => {
  if (document.hidden) {
    // Page is not visible
    isPageVisible.value = false;
    log.debug("isPageVisible:", isPageVisible.value);
  } else {
    // Page is visible
    isPageVisible.value = true;
    log.debug("isPageVisible:", isPageVisible.value);
    // iframeKey.value += 1;
    iframeKey.value = 1;
    log.debug("iframeKey:", iframeKey.value);
  }
};

// Add event listener for visibility change
onMounted(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange);
});

// Remove event listener when the component is unmounted
onBeforeUnmount(() => {
    document.removeEventListener('visibilitychange', handleVisibilityChange);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("iframe", {
      title: "DashboardReports",
      src: _unref(pbi),
      frameborder: "0",
      allowFullScreen: "true",
      key: iframeKey.value
    }, null, 8, _hoisted_2))
  ]))
}
}

})